import axios from "axios";
import {ApiConf} from "@/js/api/ApiConf";
import Tear from "@/js/utils/Tear";
import {MessageBox} from "element-ui";
import User from "@/js/User";

const service = axios.create({
  baseURL: ApiConf.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 3000000, // request timeout
  headers: {'Content-Type': 'application/json'},
  transformRequest: [(data, headers) => {
    return data
  }],
})


export const configCallback = config => {
  return config
}

// request interceptor
service.interceptors.request.use(
  configCallback,
  error => {
    Tear.errToast('操作失败，请稍候再试！')
    return Promise.reject(error)
  }
)


export const errCallback = error => {
  console.log('err',
    error
  ) // for debug
  if (!error.config.hideErr) {
    Tear.errToast(error.message)
  }
  return Promise.reject(error)
}
// response interceptor
service.interceptors.response.use(
  null,
  errCallback
)


export default class HttpProvider {

  request(option) {
    return service(option)
  }

  response(option, res) {
    if (res.code !== 0) {
      if (res.code !== -1) {
        Tear.errToast(`${res.msg || '网络异常'}`)
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 401 || res.code === 1003 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('登录超时或无权操作!',
          '提示', {
            confirmButtonText: '重新登录',
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
          User.logout()
        })
      }
      return true
    }
    return false
  }
}
